import { CheckIcon, XIcon } from "@heroicons/react/outline";

import { ReportScore } from "@/types/evaluate";
import { SUCCEED_BOOLEAN_THRESHOLD } from "@/utils/evaluate";

const getScoreColor = (scoreValue: number): string => {
  if (scoreValue === 100) {
    return "text-green-500 font-semibold";
  }

  if (scoreValue > SUCCEED_BOOLEAN_THRESHOLD) {
    return "text-gray-600";
  }

  return "text-red-500 font-semibold";
};

const evaluationScoreText = (
  score: ReportScore | null,
  iconClass = "mr-1 inline h-3.5 w-auto",
): {
  scoreFormatted: string;
  scoreText: string;
  scoreColor: string;
  scoreIcon: JSX.Element | null;
} => {
  if (!score) {
    return {
      scoreFormatted: "",
      scoreText: "",
      scoreColor: "",
      scoreIcon: null,
    };
  }

  let scoreText = "";
  let scoreColor = "";
  let scoreFormatted = "";
  let scoreIcon = null;
  // eslint-disable-next-line no-param-reassign
  score = (score.type && score) || { type: typeof score, value: score };

  if (score.type === "boolean") {
    scoreFormatted = `${score.value.toFixed(0)}%`;
    scoreText = score.value === 100 ? "Pass" : `${score.value.toFixed(0)}% passing`;
    scoreColor = getScoreColor(score.value);
    scoreIcon =
      score.value > SUCCEED_BOOLEAN_THRESHOLD ? (
        <CheckIcon className={iconClass} />
      ) : (
        <XIcon className={iconClass} />
      );
  } else if (score.type === "number") {
    scoreFormatted = score.value.toFixed(2);
    scoreText = `Score: ${score.value.toFixed(2)}`;
    scoreColor = "text-gray-600";
    scoreIcon = <CheckIcon className={iconClass} />;
  }

  return { scoreFormatted, scoreText, scoreColor, scoreIcon };
};

export const VersionScore = ({ score }: { score: ReportScore | null }) => {
  const { scoreText, scoreColor, scoreIcon } = evaluationScoreText(score);
  return scoreText ? (
    <div className={`flex items-center justify-between ${scoreColor}`}>
      {scoreIcon}
      {scoreText}
    </div>
  ) : null;
};
